import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { GeneratedUserFull } from '@repo/backend-api-spec';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class UserApiService extends BaseAPI {
  public async getUserMe() {
    return await lastValueFrom(this.get<GeneratedUserFull>('/user/me'));
  }
}
